import React, { useEffect, useState } from 'react';

const ContactUsSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section style={styles.section}>
      <h2 style={styles.heading}>Contact Us</h2>
      <div style={{ 
        ...styles.wrapper, 
        flexDirection: isMobile ? 'column' : 'row' 
      }}>
        {/* Left Side */}
        <div style={{ 
          ...styles.leftBox,
          borderRight: isMobile ? 'none' : '1px solid #f0f0f0',
          borderBottom: isMobile ? '1px solid #f0f0f0' : 'none'
        }}>
          <h3 style={styles.subheading}>Get In Touch</h3>
          <p style={styles.paragraph}>
            Have questions about HBSU? Want to collaborate? Reach out and our team will get back to you as soon as possible.
          </p>
        
        </div>

        {/* Right Side (Form) */}
        <div style={styles.rightBox}>
          <h3 style={styles.subheading}>Send us a Message</h3>
          <form style={styles.form}>
            <div style={{ 
              ...styles.row, 
              flexDirection: isMobile ? 'column' : 'row' 
            }}>
              <input type="text" placeholder="Name" style={{ 
                ...styles.input, 
                width: isMobile ? '100%' : '48%' 
              }} />
              <input type="email" placeholder="Email" style={{ 
                ...styles.input, 
                width: isMobile ? '100%' : '48%' 
              }} />
            </div>
            <textarea placeholder="Message" rows="4" style={styles.textarea}></textarea>
            <input type="text" placeholder="Phone Number" style={styles.input} />
            <div style={{ textAlign: isMobile ? 'center' : 'right' }}>
              <button type="submit" style={styles.button}>SEND MESSAGE</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '50px 20px',
    backgroundColor: '#fff',
    fontFamily: 'Arial, sans-serif'
  },
  heading: {
    textAlign: 'center',
    color: '#FFA500',
    fontSize: '30px',
    marginBottom: '40px',
    borderBottom: '3px solid #FFA500',
    display: 'inline-block',
    paddingBottom: '5px'
  },
  wrapper: {
    maxWidth: '1100px',
    margin: '0 auto',
    display: 'flex',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundColor: '#FFF8E1',
    boxShadow: '0 4px 25px rgba(0,0,0,0.1)'
  },
  leftBox: {
    flex: '1',
    padding: '30px',
    backgroundColor: '#FFF8E1'
  },
  rightBox: {
    flex: '1',
    padding: '30px',
    backgroundColor: '#fff'
  },
  subheading: {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '15px'
  },
  paragraph: {
    color: '#333',
    fontSize: '15px',
    marginBottom: '20px'
  },
  infoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '15px',
    gap: '10px'
  },
  icon: {
    fontSize: '20px',
    color: '#FFA500',
    marginTop: '2px'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '10px'
  },
  input: {
    padding: '10px',
    fontSize: '14px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    width: '100%'
  },
  textarea: {
    padding: '10px',
    fontSize: '14px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    resize: 'none',
    width: '100%'
  },
  button: {
    backgroundColor: '#FFA500',
    color: '#fff',
    padding: '12px 25px',
    fontSize: '14px',
    borderRadius: '30px',
    border: 'none',
    cursor: 'pointer',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    transition: '0.3s'
  }
};

export default ContactUsSection;
